import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
import Notifications from "react-notification-system-redux";
import {
	MuiThemeProvider,
	createMuiTheme,
	withStyles,
} from "@material-ui/core/styles";
import createPalette from "@material-ui/core/styles/createPalette";
import "./App.css";
import moment from "moment";
import "moment/locale/fr";
import { withRouter } from "react-router-dom";
import LocationListener from "../components/LocationListener";
import { loadActiveUser } from "../redux/users/usersActions";
import HeaderContainer from "./Layout/HeaderContainer";
import BodyContainer from "./Layout/BodyContainer";
import Loader from "../components/Basics/Loader";
import {
	hideMenu,
	scrollYChange,
	setIsExtranetApp,
	setTransparentFooter,
} from "../redux/contextInfos/contextInfosActions";
import BackToTop from "../components/Basics/BackToTop";
import { arraysAreSame } from "../lib/array_helper";
import Debugger from "../components/Debug/Debugger";
import { mobileAndTabletCheck } from "../utils";
import performanceModeManager from "../performanceModeManager";
import { getStateAccessor } from "../lib/evaluateStringAsCodeHelper";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../utils.css";
import { WEBSITE_LINK } from "../constants";
import { loadCurrentNews } from '../redux/news/newsActions';
import FooterFixedOnPage from "./Layout/FooterFixedOnPage";
import { getSites } from '../redux/customerSite/customerSiteActions'
import { Hidden, Link } from "@material-ui/core";
import { clearHiddenHomeWidgets } from "../redux/home/homeWidgetActions";

export const theme = createMuiTheme({
	typography: {
		"fontFamily": `"EDF2020", "Arial", sans-serif`,
		"fontSize": 14,
		"fontWeightLight": 300,
		"fontWeightRegular": 400,
		"fontWeightMedium": 500
	},
	palette: createPalette({
		primary: {//1089FF
			main: "#1057C8",
			dark: "#001A70",
			contrastText: "#F5F6F5",
		},
		secondary: {
			light: "#88D910",
			main: "#4F9E30",
			contrastText: "#F5F6F5",
		}
	}),
});

const style = {
	background: '#DDDDDD'
};

class ExtranetApp extends Component {
	constructor(props) {
		super(props);

		this.props.loadActiveUser((user) => {
			if (user)
				this.props.getSites(user.id);
		});

		moment.locale("fr");
		this.state = props.getDefaultSyncState();
		this.state.scrollPosition = 0;
		this.state.enableDebugger = mobileAndTabletCheck(); //Enable only on mobile device else we lose informations on console logs

		this.container = React.createRef();

		performanceModeManager();
		this.props.loadCurrentNews();
		this.props.setTransparentFooter(true);
		this.props.setIsExtranetApp();
	}

	launchSynchronisations() {
		this.props.initSynchronisations(
			this.state,
			getStateAccessor(this.props),
			this.props.history,
			this.props.interventionsFilters,
			this.props.siteMonitoringsFilters
		);
	}

	onScroll() {
		this.displayOrHideStickyMenu();
	}

	displayOrHideStickyMenu() {
		if (this.container.current.scrollTop > this.state.scrollPosition)
			this.props.hideMenu(true);
		else this.props.hideMenu(false);

		this.setState({ scrollPosition: this.container.current.scrollTop });
		this.props.scrollYChange(this.container.current.scrollTop);
	}

	backToTop() {
		this.container.current.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	shouldComponentUpdate(nextProps, prevState) {
		let sitesAreDifferents = !arraysAreSame(this.props.sites.sites, nextProps.sites.sites);

		return (
			!arraysAreSame(this.props.notifications, nextProps.notifications) ||
			this.props.activeUser !== nextProps.activeUser ||
			this.props.context.debugging !== nextProps.context.debugging ||
			this.state.enableDebugger !== prevState.enableDebugger ||
			sitesAreDifferents ||
			this.props.sites.selectedSite !== nextProps.sites.selectedSite
		);
	}

	redirectToWebsite() {
		window.open(WEBSITE_LINK, "_blank");
	}

	onRestoreHomePageClick() {
		this.props.clearHiddenHomeWidgets(this.props.activeUser.id);
	}

	render() {
		const { notifications } = this.props;

		if (this.props.sites.length <= 0)
			return null;

		return (
			<MuiThemeProvider theme={theme}>
				<div
					style={style}
					id="container"
					onScroll={this.onScroll.bind(this)}
					onTouchMove={this.onScroll.bind(this)}
					ref={this.container}
					className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding my-open-container"
				>
					<LocationListener container={this.container}>
						<HeaderContainer
							appBar={this.props.appBar}
							publicRoutes={this.props.publicRoutes}
							privateRoutes={this.props.privateRoutes}
						/>
						<div className="body-container app-with-sidebar">
							<BodyContainer
								container={this.container}
								publicRoutes={this.props.publicRoutes}
								privateRoutes={this.props.privateRoutes}
							/>
						</div>
					</LocationListener>
					<Notifications notifications={notifications} />
					<BackToTop backToTop={this.backToTop.bind(this)} />
					<FooterFixedOnPage>
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 home-with-sidebar white-text">
							<div className="span-center">
								<Link href="#" onClick={this.redirectToWebsite} className="white-text">
									Infos Dalkia Froid Solutions
  								</Link>
								{" - "}
								{/* <Link to="/" className="white-text">
									FAQ
                            	</Link> 
								{" - "}*/}
								<Link to="/" className="white-text" href="#" >
									Mentions légales
                            	</Link>
								<Hidden only={["xl", "lg", "md"]}>
									{" - "}
									<Link to="/" className="white-text" href="#" onClick={this.onRestoreHomePageClick.bind(this)}>
										{"Réinitialiser l'accueil"}
									</Link>
								</Hidden>
							</div>
						</div>
					</FooterFixedOnPage>
					{this.state.enableDebugger && this.props.context.debugging && (
						<Debugger />
					)}
				</div>
				<Loader />
			</MuiThemeProvider>
		);
	}
}

ExtranetApp.propTypes = {
	notifications: PropTypes.array,
};

const mapStateToProps = (state) => {
	return {
		notifications: state.notifications,
		activeUser: state.activeUser,
		context: state.context,
		interventionsFilters: state.interventions,
		sites: state.sites,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		loadActiveUser: (onSuccess) => dispatch(loadActiveUser(onSuccess)),
		hideMenu: (value) => dispatch(hideMenu(value)),
		scrollYChange: (scrollY) => dispatch(scrollYChange(scrollY)),
		loadCurrentNews: () => dispatch(loadCurrentNews()),
		setTransparentFooter: (transparent) => dispatch(setTransparentFooter(transparent)),
		setIsExtranetApp: () => dispatch(setIsExtranetApp()),
		getSites: (userId) => dispatch(getSites(userId)),
		initSynchronisations: (
			state,
			stateAccessor,
			history,
			interventionsFilters,
			siteMonitoringsFilters
		) =>
			dispatch(
				ownProps.initSynchronisations(
					state,
					stateAccessor,
					history,
					interventionsFilters,
					siteMonitoringsFilters
				)
			),
		clearHiddenHomeWidgets: (userId) => dispatch(clearHiddenHomeWidgets(userId)),
	};
};

export default compose(
	withRouter,
	withStyles({ withTheme: true }),
	connect(mapStateToProps, mapDispatchToProps)
)(ExtranetApp);
